import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { institutionsScreen } from '@/ui/pages/Institutions/institutionsScreen';

/** HS-869: the list is a `@smartsash/data-screen` definition — see `groups.index.tsx`. */
const InstitutesListScreen = institutionsScreen.ListScreen;

export const Route = createFileRoute('/_dashboard/institutions/')({
  validateSearch: institutionsScreen.validateSearch,
  loaderDeps: institutionsScreen.loaderDeps,
  beforeLoad: requireRoute('/institutions'),
  loader: institutionsScreen.loaderFor(),
  component: InstitutesListScreen,
});
